import { useMutation } from "@tanstack/react-query";

import { loginRequest } from "../requests/login-request";

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: loginRequest,
  });
};
